export default (namespace) => ({
  [`${namespace}.firstTitle`]: 'Dinos cómo eres',
  [`${namespace}.secondTitle`]: 'Quiero estas coberturas',
});
